import { CollaborationDTO, UserRole } from '@inversor-hub/types';

export function hasUserSigned(collab: CollaborationDTO | undefined, role: UserRole): boolean {
  if (!collab) return false;
  return role === 'investor' ? collab.investorSigned : collab.psiSigned;
}

export function bothHaveSigned(collab: CollaborationDTO | undefined): boolean {
  if (!collab) return false;
  return collab.investorSigned && collab.psiSigned;
}
